/**
 * Normalizes URL construction to avoid double slashes
 * Removes trailing slashes from base and leading slashes from path before joining
 *
 * Example:
 *   normalizeUrl('https://example.com/backend/', '/api/endpoint')
 *   => 'https://example.com/backend/api/endpoint'
 *
 * This prevents double slashes when API_URL ends with '/' and paths start with '/'
 */
export function normalizeUrl(base: string, path: string): string {
  const baseNormalized = base.replace(/\/+$/, ''); // Remove trailing slashes
  const pathNormalized = path.replace(/^\/+/, ''); // Remove leading slashes
  return `${baseNormalized}/${pathNormalized}`;
}
